import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getSuppliesSubscriptionsCount = unaryRpc({
  name: "getSuppliesSubscriptionsCount" as const,
  input: z.object({}),
  output: z.object({ total: z.number() }),
});
